import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75721ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel-player" }

import {AspectRatio} from "@/lib/components/flexible/enum/AspectRatio";
import {PageContentLayoutSpaceTaken} from "@/lib/components/layout/page/enum/PageContentLayoutSpaceTaken";
import {CarouselShortcut} from "@/lib/components/frame/carousel/type/CarouselShortcut";
import {CarouselShortcutType} from "@/lib/components/frame/carousel/enum/CarouselShortcutType";
import OverlayableImagesCarousel from "@/lib/components/frame/carousel/image/OverlayableImagesCarousel.vue";
import AppPage from "@/layouts/AppPage.vue";
import {PropType} from "vue";
import {Ref, ref, watch} from "vue";
import BoundingBoxOverlay from "@/components/frame/image/annotation/BoundingBoxOverlay.vue";
import {SAnnotatableImageData} from "@/store/Spatial2DAnnotation/model/SAnnotatableImageData";
import {SImageData} from "@/lib/store/model/media/SImageData";
import {
  AnnotatableImagesStoreManager
} from "@/store/Spatial2DAnnotation/manager/AnnotatableImagesStoreManager";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'CowImagesAnnotationPage',
  props: {
  annotatableImages: Array as PropType<SAnnotatableImageData[]>,
},
  setup(__props, { expose }) {

const props = __props




// ------------------------------
//  Images carousel data
// ------------------------------

const images: Ref<SImageData[]> = ref([]);

watch(() => props.annotatableImages, () => {
  if (props.annotatableImages)
    images.value = props.annotatableImages.map(annotatableImage => annotatableImage.image);
});

// ------------------------------
//  Images carousel display
// ------------------------------

const overlayableImagesCarouselRef = ref();

const getOverlaySlotName = (annotatableImageData: SAnnotatableImageData) => {
  return "overlay " + annotatableImageData.image.instanceId;
}

// ------------------------------
//  Images carousel shortcuts
// ------------------------------

const carouselShortcuts: CarouselShortcut[] = [
  {
    type: CarouselShortcutType.TO_PREVIOUS_SLIDE,
    keyCode: "ArrowLeft"
  },
  {
    type: CarouselShortcutType.TO_NEXT_SLIDE,
    keyCode: "ArrowRight"
  },
  {
    type: CarouselShortcutType.TO_FIRST_SLIDE,
    requiresCtrl: true,
    keyCode: "ArrowLeft"
  },
  {
    type: CarouselShortcutType.TO_LAST_SLIDE,
    requiresCtrl: true,
    keyCode: "ArrowRight"
  },
];

// ------------------------------
//  Preparation for annotating
// ------------------------------

const onImageSelectedAfter = (image: SImageData) =>
{
  AnnotatableImagesStoreManager.setCurrentAnnotatableImageFromImageData(image);
}

// ------------------------------
//  Ref exposition
// ------------------------------

expose({
  overlayableImagesCarouselRef
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppPage, {
    "aspect-ratio": _unref(AspectRatio)['16/9'],
    "page-content-layout-space-taken": _unref(PageContentLayoutSpaceTaken).ALL
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(OverlayableImagesCarousel, {
          images: images.value,
          shortcuts: carouselShortcuts,
          ref_key: "overlayableImagesCarouselRef",
          ref: overlayableImagesCarouselRef,
          onOnImageSelectedAfter: onImageSelectedAfter
        }, _createSlots({ _: 2 }, [
          _renderList(__props.annotatableImages, (annotatableImage) => {
            return {
              name: getOverlaySlotName(annotatableImage),
              fn: _withCtx(() => [
                _createVNode(BoundingBoxOverlay, { "annotatable-image": annotatableImage }, null, 8, ["annotatable-image"])
              ])
            }
          })
        ]), 1032, ["images"])
      ])
    ]),
    _: 1
  }, 8, ["aspect-ratio", "page-content-layout-space-taken"]))
}
}

})